module.exports = __webpack_public_path__ + "img/c240ce4.svg";